import { render } from "./HowToReturnPage.vue?vue&type=template&id=4fb02698"
import script from "./HowToReturnPage.vue?vue&type=script&lang=js"
export * from "./HowToReturnPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__